import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
/*
 * @FilePath: \ch-pc\src\service\loginService\loginService.js
 * @Description: 登录相关
 */
import { queryUserInfoByMobile as _queryUserInfoByMobile } from '@/api/apiUrl';
import { queryStaffInfoByOperatorCodeApi } from '@/api/apiHRManagement';
var LoginService = /*#__PURE__*/function () {
  function LoginService() {
    _classCallCheck(this, LoginService);
  }
  _createClass(LoginService, [{
    key: "queryUserInfoByMobile",
    value:
    /**
     * 根据操作员operatorCode查询操作员信息
     * @param operatorCode 操作员code或手机号
     * */
    function () {
      var _queryUserInfoByMobile2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(operatorCode) {
        var resrole, staffRes;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _queryUserInfoByMobile(operatorCode);
              case 2:
                resrole = _context.sent;
                _context.prev = 3;
                _context.next = 6;
                return queryStaffInfoByOperatorCodeApi(resrole.content.operatorCode);
              case 6:
                staffRes = _context.sent;
                resrole.content['staffInfo'] = staffRes.data;
                _context.next = 12;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
              case 12:
                return _context.abrupt("return", resrole);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));
      function queryUserInfoByMobile(_x) {
        return _queryUserInfoByMobile2.apply(this, arguments);
      }
      return queryUserInfoByMobile;
    }()
  }]);
  return LoginService;
}();
export { LoginService as default };